export default __webpack_public_path__ + "static/5-73172c4bfb6ef849d81d20949a44cc4d.jpeg";